import { EntityState } from "@ngrx/entity";

import { CampaignEntity } from '../entities';

export interface CampaignState extends EntityState<CampaignEntity> {
    selectedId: number,
    isLoading: boolean,
    isLoaded: boolean,
    prevUrl: string,
    nextUrl: string
}